import React, { Component } from 'react';
import './Confermail.css';
//import cfve from '../../images/public/registeration/cfve.png';
import clos from '../../images/public/registeration/clos.png';
//import { element } from 'prop-types';
//import classNames from 'classnames';
//import { BrowserView, MobileView, isBrowser, isMobile, isFirefox, isTablet, isMobileOnly, isAndroid, isIOS, browserName } from 'react-device-detect';
import { BrowserView, MobileView } from 'react-device-detect';
//import { Rectangle, Circle, Ellipse, Line, Polyline, CornerBox, Triangle } from 'react-shapes';
//import { RadioGroup, Radio } from 'react-radio-group';
//import { height } from 'window-size';
//import WebFont from 'webfontloader';
//import { BrowserRouter as Router, Route, Link, Redirect } from "react-router-dom";
import { BrowserRouter as Router } from "react-router-dom";
//import Termini from '../Termini/Termini';
import tr from '../../libs/tr'
import AlertPnl from "../../assets/components/panel/AlertPnl";
import Cookies from 'universal-cookie';
//import Haisbaglimail from '../Haisbaglimail/Haisbaglimail';
import { confirmEmail, sendWelcomeEmail, sendCodeByEmail, userLogoutFetch } from '../../libs/fetch';
//import Mainindex from '../Mainindex/Mainindex';
//import itabar1 from '../../images/public/registeration/nav1i.png';
//import engbar1 from '../../images/public/registeration/nav1e.png';
//import simplebar1 from '../../images/public/registeration/mobilenav1.png';
import TopBar from '../../assets/components/topbar/TopBar';
import ProgressBullets from '../../assets/components/progressBullets/ProgressBullets';
//import miniArrow from '../../images/public/registeration/miniarrow.png';
import logo from '../../images/public/login/logo.png';
//import help from '../../images/public/userarea/tab5u.png';
import FirebaseLogger from '../../libs/FirebaseLogger';

const cookies = new Cookies();

// init user from storage
let user;
class Confermail extends Component {
	constructor(props) {
			super(props);

			this.state = {
				step: '1',
				loadedData: false,
				redirect: false,
				redirectprev: '',
				userRegResponse: '',
				userInfo: '',
				regCode: '',
				regCodeErr: false,
				email: '',
				emailmod: '',
				username: '',
				isModEmail: false,
				isResendCode: false,
			};

			// handler bind
			this.handleChangeCode = this.handleChangeCode.bind(this);
			this.handlegotoModifyEmail = this.handlegotoModifyEmail.bind(this);
			this.handleSendCodeByMail = this.handleSendCodeByMail.bind(this);
		}

		componentWillMount() {
		}

		componentDidMount() {
			//TODO uncomment the 3lines

			//console.log('storage', localStorage.getItem('user'));
			if (!localStorage.getItem('user')) {
				return this.props.history.push('/');
			}

			user = JSON.parse(localStorage.getItem('user'));
			this.setState({ loadedData: true });
			const { email } = '';
			const { info } = '';
		}

		goToConfirmPhone = (e) => {
			/**/
			e.preventDefault();

			if (this.canBeSubmitted() && this.validateInput()) {
			try {
				confirmEmail(this, {
					email: user.email,
					confirmEmailCode: this.state.regCode,
					language: tr.userlng()
			}).then((response) => {

					console.log(response);

					if (response === null) {
							return;
					}
					if (response.status === "fail") {
							this.setState({ regCodeErr: true });
							// alert(response.message)
							this.handleAlert(response.message);

					}
					if (response.status === "success") {
							try {
									sendWelcomeEmail(this, {
											id_facebook: '',
											email: user.email,
											portal: 'sci',
											language: tr.userlng()
									}).then((response) => {

											console.log("sendCodeByEmail: response: ", response)

											if (response == null) {
													return;
											}

											if (response.status === "fail") {
													// alert(response.message);
													this.handleAlert(response.message);
											}

											if (response.status === "success") {
                        // Registration procedure completed
                          window._fbq('track', 'CompleteRegistration', {
                            content_name: 'EUR'
                          });
                          

                        FirebaseLogger.getInstance().regEvent("NORMAL_REGISTERATION",
                        { 
                          user_id: user.user_id,
                          name: user.name,
                          surname: user.surname,
                          email: user.email,
                          phone: user.phone
                         }, "NEW");

													this.props.history.push({
															pathname: '/confirm-phone'
													});
											}

											else {
													// alert(response.message);
													this.handleAlert(response.message);
											}

									})

							} catch (error) {
									console.error(error);
							}

					}

										else {
												// alert(response.message);
												this.handleAlert(response.message);
										}

								});

						} catch (error) {
								console.log('ERROR: ', error);
						}
				}
				else {
						console.log('cannot submit form');
				}

				/**/

		}



		canBeSubmitted = () => {
				var validCode = (this.state.regCode.length > 4) && !this.state.regCodeErr;
				return validCode;
		}

		validateInput = () => {
				return this.validateCode();
		}

		validateCode = (e) => {
				var validCode = (this.state.regCode != '');
				this.setState({ regCodeErr: !validCode });
				return validCode;
		}



		/* handles for each input values changes */
		handleChangeCode = (e) => {
				this.setState({ regCode: e.target.value }, () => {

						this.setState({ regCodeErr: false });

						// if (this.state.regCode.length > 4) this.goToConfirmPhone();

				})

		}


		// RESEND EMAIL

		handleSendCodeByMail = (e) => {

				e.preventDefault();
				this.setState({regCode:''});
				// Rest Call
				try {
						sendCodeByEmail(this,
								{
										email: user.email,
										one_step: 1,
										language: tr.userlng()
								}).then((response) => {

										console.log("modifyEmail: response: ", response)

										if (response === null) {
												return;
										}
										if (response.status === "fail") {
												console.log("modifyEmail: !!FAIL!!: ", response.message)
												this.setState({ redirect: false, redirectprev: true });
												//alert(response.status)
												this.handleAlert(response.status);
												// modify Email
												// send Code By mail
										}
										if (response.status === "success") {
												// alert(tr.t("success"))
												// this.handleAlert(tr.t("success"), true);
												this.handleAlert(tr.t("EmailSentSuccessfully"), true);

										}


								});

				} catch (e) {
						// alert(e);
						this.handleAlert(e);
				}
				return;


		}

		// redirect to resend-mail route
		resendMail = (e) => {
				this.props.history.push({
						pathname: '/resend-mail'
				});
		}

		handlegotoModifyEmail = (e) => {
				e.preventDefault();
				this.resendMail(e);
				/*
				console.log('handlegotoModifyEmail')
				this.setState({ isModEmail: true })
				this.setState({ redirect: true, redirectprev: true });
				const { isResendCode, isModEmail } = this.state
				console.log('xxxxxx isResendCode  isModEmail !!', isResendCode, isModEmail);
				*/
		}

		handleCloseform = (e) => {
				e.preventDefault();
				return this.setState({ closing: true });

		}

		// LOGOUT! if user decides to  close the terms
		logout = () => {
				try {
						// fill storage w/ user data.
						userLogoutFetch(this).then((response) => {
								console.log(response);
								localStorage.clear();
								cookies.remove('access_token');
								return this.props.history.push('/');
						});
				} catch (e) {
						console.log(e);
				}
		}

		alertResponse(info) {
				switch (info.type) {
						case "closeButton":
								this.setState({ inScreenPopupShow: false, OKPopupShow: false, closing: false })
								break;
						case "actionButton":
								if (info.option1 === "attention") {
										this.setState({ inScreenPopupShow: false, OKPopupShow: false });
										break;
								}
								if (info.option1 === "cancel") {
										this.setState({ closing: false });
										break;
								}
								if (info.option2 === "exit") {
										this.setState({ closing: false }, () => {
												this.logout();
										});
										break;
								}
				}
		}

		// Default browser alert function replacement
		handleAlert = (incomingMsg, notitle) => {
				console.log("Incoming message:", incomingMsg);
				if (notitle) {
						return this.setState({
								OKPopupShow: true,
								inScreenPopupMsg: incomingMsg,
						});
				}
				this.setState({
						inScreenPopupShow: true,
						inScreenPopupMsg: incomingMsg,
				})
		}

		render() {

				//
				const userInfo = JSON.parse(localStorage.getItem('user'));

				const isDisabled = !this.canBeSubmitted();

				const { isResendCode, isModEmail } = this.state

				return (
					<Router>
						<div>
							{
								this.state.loadedData &&
								<div>
									<BrowserView>
										<div className="container-fluid d-lg-none sn_mobile_top_row mt-5">
											<div className="row flex-nowrap">
												<div className="col-2 d-flex align-items-center">
											
												</div>
												<div className="col-8 d-flex align-items-center justify-content-center">
													<img className="sn_mobile_top_row_logo" src={ logo } />
												</div>
												<div className="col-2 d-flex align-items-center justify-content-end">
													<div className="sn_exit">
														<a onClick={this.handleCloseform}>
															<img src={ clos } />
														</a>
													</div>
												</div>
											</div>
										</div>
										<div className="sn_topbar"><TopBar step={ this.state.step }/></div>
										<div className="sn_overlay d-lg-none"></div>
										<div className="sn_confirm">
											<div className="container-fluid">
												<div className="row">
													<div className="col-12 col-lg-10 mx-auto">
														<div className="sn_register__container">
															<div className="row">
																<div className="col-3 d-none d-lg-block">
																	<div className="big_arrow_wrap"><div className="big_arrow"></div></div>
																</div>
																<div className="col-12 col-lg-9">
																	<div className="row">
																		<div className="col-12 d-flex justify-content-end">
																			<div className="sn_exit d-none d-lg-block">
																				<a onClick={this.handleCloseform}>
																					<img src={ clos } />
																				</a>
																			</div>
																		</div>
																	</div>
																<div className="row mb-3">
																	<div className="col-12">
																		<h3 className="mb-5">{ tr.t("Confirmbymail") }</h3>
																		<p className="mb-5">
																			{ tr.t("Insertcode") }
																			&#160;
																			{tr.t("Yourmail")}
																			&#160;
																			<b>{ userInfo.email }</b>
																		</p>
																		<input type="tel" name="code" placeholder="12345" className={(this.state.regCodeErr) ? "sn_input err_red" : "sn_input err_no"} maxLength="5" value={this.state.regCode} onChange={this.handleChangeCode} />
																	</div>
																</div>
																<div className="row mb-5">
																	<div className="col-12 col-md-6 mb-3 mb-sm-0">
																		<a onClick={ this.handleSendCodeByMail }><h5>{ tr.t("Resend") }</h5></a> 
																	</div>
																	<div className="col-12 col-md-6 text-left text-md-right">
																		<a onClick={ this.handlegotoModifyEmail }><h5>{ tr.t("Wrong") }</h5></a>
																	</div>
																</div>
																<div className="row">
																	<div className="col-12 d-flex justify-content-center justify-content-md-end">
																		<button className="sn_btn" onClick={ this.goToConfirmPhone } disabled={ isDisabled }>{ tr.t("Next") }</button>
																	</div>
																</div>
																</div>
															</div>
															<div className="row d-lg-none mt-5">
																<div className="col-12">
																	<ProgressBullets step={ this.state.step } />
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</BrowserView>
									<MobileView>
										<div className="container-fluid d-lg-none sn_mobile_top_row mt-5">
											<div className="row flex-nowrap">
												<div className="col-2 d-flex align-items-center"></div>
												<div className="col-8 d-flex align-items-center justify-content-center">
													<img className="sn_mobile_top_row_logo" src={ logo } />
												</div>
												<div className="col-2 d-flex align-items-center justify-content-end">
													<div className="sn_exit">
														<a onClick={this.handleCloseform}>
															<img src={ clos } />
														</a>
													</div>
												</div>
											</div>
										</div>
										<div className="sn_topbar"><TopBar step={ this.state.step }/></div>
										<div className="sn_overlay d-lg-none"></div>
										<div className="sn_confirm">
											<div className="container">
												<div className="row">
													<div className="col-12 col-lg-8 mx-auto">
														<div className="sn_register__container">
															<div className="row">
																<div className="col-12 d-flex justify-content-end">
																	<div className="sn_exit d-none d-lg-block">
																		<a onClick={this.handleCloseform}>
																			<img src={ clos } />
																		</a>
																	</div>
																</div>
															</div>
															<h3>{ tr.t("Confirmbymail") }</h3>
															<p>
																{ tr.t("Insertcode") }
																&#160;
																{tr.t("Yourmail")}
																&#160;
																<b>{ userInfo.email }</b>
															</p>
															<div className="sn_input mb-2">
																<input type="tel" name="code" placeholder="12345" className={(this.state.regCodeErr) ? "txlf1" : "txlf"} maxLength="5" value={this.state.regCode} onChange={this.handleChangeCode} />
															</div>
															<div className="d-flex justify-content-between mb-3">
																<a  onClick={ this.handleSendCodeByMail }><h5>{ tr.t("Resend") }</h5></a> 
																<a  onClick={ this.handlegotoModifyEmail }><h5>{ tr.t("Wrong") }</h5></a>
															</div>
															<div className="row">
																<div className="col-12 d-flex justify-content-end">
																	<button className="sn_btn" onClick={ this.goToConfirmPhone } disabled={ isDisabled }>{ tr.t("Next") }</button>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</MobileView>
								</div>
							}
							{
								this.state.inScreenPopupShow ?
									<div className="containerModal">
										{
											this.state.inScreenPopupShow ?
											<AlertPnl textbar1={tr.t("Attention")} secondbar={true} textbar2={this.state.inScreenPopupMsg} singlebtn={true} textbtn1={tr.t("Ok")} sizebtn={"medium"} option1={"attention"} callback={this.alertResponse.bind(this)} /> : null
										}
									</div> : null
							}
							{ 
								this.state.OKPopupShow ?
									<div className="containerModal">
										{
											this.state.OKPopupShow ?
											<AlertPnl textbar1={" "} secondbar={true} textbar2={this.state.inScreenPopupMsg} singlebtn={true} textbtn1={tr.t("Ok")} sizebtn={"medium"} option1={"attention"} callback={this.alertResponse.bind(this)} /> : null
										}
									</div> : null
							}
							{
								this.state.closing ?
									<div className="containerModal">
										{
											this.state.closing ?
											<AlertPnl textbar1={tr.t("Attention")} secondbar={true} textbar2={tr.t("cantcloseEmailForm")} doublebtnhor={true} textbtn1={tr.t("Cancel")} textbtn2={tr.t("Ok")} option1={"cancel"} option2={"exit"} callback={this.alertResponse.bind(this)} /> : null
										}
									</div> : null
							}
						</div>
					</Router>
				);
		}
}

export default Confermail;


// WEBPACK FOOTER //
// ./src/screens/Confermail/Confermail.js